import React from 'react';
import { FiscalAddress, AddressType, CustomerType, EditStatus } from 'common';
import { CommonConsultView } from '../common/consult-view';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { changeFiscalAddressPath } from '../../../navigation/paths';
import { CommonEditView } from '../common/edit-view';

type FiscalAddressSectionProps = {
    address?: FiscalAddress;
    customerType?: CustomerType;
    lastEditStatus?: EditStatus;
    startEditing: () => void;
    cancelEditing: (addressType: AddressType) => void;
    finishEditing: (addressType: AddressType, newEditStatus: EditStatus, updatedAddress?: FiscalAddress) => void;
};

export const FiscalAddressSection: React.FC<FiscalAddressSectionProps> = ({
    address,
    customerType,
    lastEditStatus,
    startEditing,
    cancelEditing,
    finishEditing,
}) => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={changeFiscalAddressPath()}>
                <CommonEditView
                    addressType={AddressType.FISCAL}
                    address={address}
                    cancelEditing={cancelEditing}
                    finishEditing={finishEditing}
                    customerType={customerType}
                />
            </Route>
            <Route path={path}>
                <CommonConsultView
                    address={address}
                    addressType={AddressType.FISCAL}
                    lastEditStatus={lastEditStatus}
                    customerType={customerType}
                    startEditing={startEditing}
                />
            </Route>
        </Switch>
    );
};
